import { PickupCorporateConfigEndpoint } from "@/app/infrastructures/endpoints/horde/PickupCorporateConfigEndpoint";
import { PickupCorporateScheduleConfigEndpoint } from "@/app/infrastructures/endpoints/horde/PickupCorporateScheduleConfigEndpoint";
import { PickupCorporateConfigApiRepository } from "@/app/infrastructures/repositories/api/PickupCorporateConfigApiRepository";
import { PickupCorporateScheduleConfigApiRepository } from "@/app/infrastructures/repositories/api/PickupCorporateScheduleConfigApiRepository";
import ApiService from "@/app/infrastructures/services/ApiService";
import { PickupCorporateConfigPresenter } from "@/app/ui/presenters/PickupCorporateConfigPresenter";
import { PickupCorporateScheduleConfigPresenter } from "@/app/ui/presenters/PickupCorporateScheduleConfigPresenter";
import { PickupCorporateConfigMapper } from "@/data/persistences/mappers/PickupCorporateConfigMapper";
import { PickupCorporateScheduleConfigMapper } from "@/data/persistences/mappers/PickupCorporateScheduleConfigMapper";
import { container } from "tsyringe";

export class PickupCorporateScheduleConfigComponents {
  public static init(): void {
    container.register(PickupCorporateConfigMapper, {
      useClass: PickupCorporateConfigMapper
    });
    container.register(PickupCorporateScheduleConfigMapper, {
      useClass: PickupCorporateScheduleConfigMapper
    });
    container.register(PickupCorporateConfigApiRepository, {
      useFactory: (dependencyContainer) =>
        new PickupCorporateConfigApiRepository(
          dependencyContainer.resolve(ApiService),
          dependencyContainer.resolve(PickupCorporateConfigMapper),
          dependencyContainer.resolve(PickupCorporateConfigEndpoint)
        )
    });
    container.register(PickupCorporateConfigPresenter, {
      useFactory: (dependencyContainer) =>
        new PickupCorporateConfigPresenter(
          dependencyContainer.resolve(PickupCorporateConfigApiRepository)
        )
    });
    container.register(PickupCorporateScheduleConfigApiRepository, {
      useFactory: (dependencyContainer) =>
        new PickupCorporateScheduleConfigApiRepository(
          dependencyContainer.resolve(ApiService),
          dependencyContainer.resolve(PickupCorporateScheduleConfigMapper),
          dependencyContainer.resolve(PickupCorporateScheduleConfigEndpoint)
        )
    });
    container.register(PickupCorporateScheduleConfigPresenter, {
      useFactory: (dependencyContainer) =>
        new PickupCorporateScheduleConfigPresenter(
          dependencyContainer.resolve(
            PickupCorporateScheduleConfigApiRepository
          )
        )
    });
  }
}
